export default {
  'highlights-heading':
    'Uno spazio per condividere idee, suggerimenti e - perché no - ispirarvi coi vostri regali',
}
